import { BuyToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/buytone/buytonedto';
import { SubscriptionPlanDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/subscriptionplandetails/subscriptionplandetailsdto';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState } from '../../../toolkit/uicomponent';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { SubscriptionPlanAPIModel, SubscriptionPlanAPIModelImpl } from './subscriptionplanapimodel';
import { SubscriptionPlanCSSStyleImpl } from './subscriptionplancss';
import { SubscriptionPlanViewImpl } from './subscriptionplanview';

export interface SubscriptionPlanComponentProps extends UIComponentProps
{
    headerTitle:string;
    id:string;
    toneDto:ToneDto;
    channel?:string;
    closePopup(): void;
    showPopup(id:string,msg:string,type:AlertType):void;
}

export interface SubscriptionPlanComponentState extends UIComponentState
{
    isMonthlyHovered: boolean;
    isWeeklyHovered:boolean;
    isDailyHovered:boolean;
    onPackselected:string;
   
}

export interface SubscriptionPlanComponentHandler extends UIComponentHandler
{
    
    onMonthlyHovered(isMonthlyHovered: boolean, isWeeklyHovered:boolean, isDailyHovered:boolean):void;
    onMonthlyHoveredExit():void;
    onWeeklyHovered(isMonthlyHovered: boolean, isWeeklyHovered:boolean, isDailyHovered:boolean):void;
    onWeeklyHoveredExit():void;
    onDailyHovered(isMonthlyHovered: boolean, isWeeklyHovered:boolean, isDailyHovered:boolean):void;
    onDailyHoveredExit():void;
    onCancelClick():void;
    onConfirmClick():void;
    onClick(packName:string):void;


}

export class SubscriptionPlanComponent extends UIComponentImpl<SubscriptionPlanComponentProps, SubscriptionPlanComponentState, SubscriptionPlanDetailsDto> 
implements SubscriptionPlanComponentHandler
{
    constructor(props: SubscriptionPlanComponentProps)
    {
        super(props);

        this.state = {isMonthlyHovered : false, isDailyHovered:false, isWeeklyHovered:false, onPackselected:""};
    }
  
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<SubscriptionPlanDetailsDto>
    {
        return new SubscriptionPlanViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new SubscriptionPlanCSSStyleImpl(applicationContext);
    }

   
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new SubscriptionPlanAPIModelImpl(applicationContext, apiModelHandler);
    }
    onMonthlyHovered(isMonthlyHovered: boolean, isWeeklyHovered: boolean, isDailyHovered: boolean): void 
    {
        this.setState({isMonthlyHovered:isMonthlyHovered, isWeeklyHovered:isWeeklyHovered,isDailyHovered:isDailyHovered });
    }
    onMonthlyHoveredExit(): void 
    {
        this.setState({isMonthlyHovered:false });
    }
    onWeeklyHovered(isMonthlyHovered: boolean, isWeeklyHovered: boolean, isDailyHovered: boolean): void {
        this.setState({isMonthlyHovered:isMonthlyHovered, isWeeklyHovered:isWeeklyHovered,isDailyHovered:isDailyHovered });
    }
    onWeeklyHoveredExit(): void {
        this.setState({isWeeklyHovered:false });
    }
    onDailyHovered(isMonthlyHovered: boolean, isWeeklyHovered: boolean, isDailyHovered: boolean): void {
        this.setState({isMonthlyHovered:isMonthlyHovered, isWeeklyHovered:isWeeklyHovered,isDailyHovered:isDailyHovered });
    }
    onDailyHoveredExit(): void {
        this.setState({isDailyHovered:false });
    }
   
    onCancelClick():void
    {
        this.props.context.getUserContext().setMsisdnB("");
        this.props.context.getUserContext().setSecToken("");
        this.props.context.setUserContext(this.props.context.getUserContext());
        this.props.closePopup();
    }

    onConfirmClick():void
    {
       
        if(this.getContext().getUserContext().getIsLoggedIn())
        {
            console.log("loggedIn");
            (this.getView() as SubscriptionPlanViewImpl).showLoader();
            let buyTone = new BuyToneDtoImpl();
            buyTone.setToneId(this.props.toneDto.getId());
            buyTone.setToneName(this.props.toneDto.getToneName());
            buyTone.setMsisdn(this.props.context.getUserContext().getMsisdnB());
            buyTone.setLanguage(this.props.context.getUserContext().getLanguage());
            buyTone.setPackName(this.state.onPackselected);
            buyTone.setUserName(this.props.context.getUserContext().getUsername());
            buyTone.setChannel(this.props.context.getUserContext().getChannelId());
            
            (this.getAPIModel() as SubscriptionPlanAPIModel).loggedInBuyTone(buyTone);
            
        }
        else
        {
        if(this.props.id === this.props.context.getResources().getString(Strings.buy_now))
        {
            (this.getView() as SubscriptionPlanViewImpl).showLoader();
            let buyTone = new BuyToneDtoImpl();
            buyTone.setToneId(this.props.toneDto.getId());
            buyTone.setToneName(this.props.toneDto.getToneName());
            buyTone.setMsisdn(this.props.context.getUserContext().getMsisdnB());
            buyTone.setLanguage(this.props.context.getUserContext().getLanguage());
            buyTone.setPackName(this.state.onPackselected);
            buyTone.setUserName(this.props.context.getUserContext().getMsisdnB());
            buyTone.setChannel(this.props.context.getUserContext().getChannelId());

            (this.getAPIModel() as SubscriptionPlanAPIModel).buyTone(buyTone);
        }
        
    }
    }


    onClick(packName:string):void{
        this.setState({onPackselected:packName});
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("----------buy"+this.state.onPackselected);
        (this.getView() as SubscriptionPlanViewImpl).dismissLoader();
        // (this.props.context.getUserContext().setMsisdnB(""));
        this.props.context.getUserContext().setSecToken("");
        this.props.context.getUserContext().setPackName(this.state.onPackselected);
       this.props.context.setUserContext(this.props.context.getUserContext());
        this.props.showPopup(this.getContext().getResources().getString(Strings.subscription),this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);   
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("----fail");
        (this.props.context.getUserContext().setMsisdnB(""));
        this.props.context.getUserContext().setSecToken("");
        this.props.context.setUserContext(this.props.context.getUserContext());
        (this.getView() as SubscriptionPlanViewImpl).dismissLoader();
        this.props.showPopup(this.props.context.getResources().getString(Strings.subscription),description,AlertType.ERROR);     

    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/subscription_plan/subscriptionplancomponent.tsx